import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonIcon, useIonAlert, IonFooter
} from '@ionic/react';
import {
    arrowBack,
} from 'ionicons/icons';
import JobDetails from "./JobDetails";
import useStore from "../zustand/useStore";
import {
    actionToApplyForJobPortalJobPost,
} from "../apiHelpers/CommonAction";

export default function JobDetailsSheetPopup({ isOpen, onDidDismiss,jobDetailsData,isMobile  = true}) {
    const {userAuthDetail,userJobProfileData} = useStore();
    const {userInfo} = userAuthDetail;
    const jobProfileData = userJobProfileData?.jobProfileData;
    const [presentAlert] = useIonAlert();

    const openMailClient = async (jobData) => {
        let jobApplyJson = [];
        if (jobData?.applied_member_id_array) {
            jobApplyJson = JSON.parse(jobData.applied_member_id_array);
        }

        if (!jobApplyJson?.includes(userInfo?.id)) {
            jobApplyJson.push(userInfo?.id);
            const template = await actionToApplyForJobPortalJobPost(jobData?.id, JSON.stringify(jobApplyJson));
            const subject = encodeURIComponent(`Application for Job – ${jobData?.title}`);

            let body = "Hello,\n\nI am interested in applying for this job position.\n\nThanks.";

            if (template) {
                let filledTemplate = template
                    .replace(/{JOB_TITLE}/g, jobData?.title || "-")
                    .replace(/{CV_URL}/g, jobProfileData?.cv_url || "")
                    .replace(/{NAME}/g, jobProfileData?.name || "")
                    .replace(/{MOBILE}/g, userInfo?.phone_number || "")
                    .replace(/{EMAIL}/g, jobProfileData?.email || "");

                body = encodeURIComponent(filledTemplate);
            }

            window.location.href = `mailto:${jobData?.apply_email}?subject=${subject}&body=${body}`;
        }
    };


    const applyForJob = (jobData)=>{
        if(jobProfileData?.id){
            presentAlert({
                header: 'Are you sure?',
                cssClass: 'custom_site_alert_toast',
                message: 'You want to apply for this job.',
                buttons: [
                    {text: 'Cancel', role: 'cancel'},
                    {text: 'Apply', role: 'confirm', handler: () =>openMailClient(jobData)},
                ],
            });
        }else{
            presentAlert({
                header: 'Sorry!',
                cssClass: 'custom_site_alert_toast',
                message: 'To apply for job please create your job profile.',
                buttons: [
                    {text: 'Okay', role: 'cancel'}
                ],
            });
        }
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
            data-publisher-content="true"
        >

           {(jobDetailsData?.id) ?
                <>
                    <IonHeader className="job_detail_sheet_header sheet_modal_header">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                                    <IonIcon icon={arrowBack}/>
                                </IonButton>
                            </IonButtons>
                            <div className="job_detail_sheet_header_text">
                                <div className="job-basic-info-image">
                                    <span className="job-basic-info-text">{jobDetailsData.company}</span>
                                </div>
                            </div>
                            <IonButtons slot="end">
                                {(userInfo?.id !== jobDetailsData?.created_by) &&
                                    <>
                                        {(jobDetailsData?.applied_member_id_array && JSON.parse(jobDetailsData?.applied_member_id_array).includes(userInfo?.id)) ?
                                            <div className="filter_sheet_clear_all_btn">
                                                Applied
                                            </div>
                                            :
                                            <div onClick={() => applyForJob(jobDetailsData)} className="filter_sheet_clear_all_btn">
                                                Apply
                                            </div>
                                        }
                                    </>
                               }
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding job_detail_sheet_content">
                        <JobDetails jobDetailsData={jobDetailsData}/>
                    </IonContent>
                    {(isMobile) &&
                    <IonFooter className={"blank_footer_bar"}>
                        <IonToolbar>
                            <div id={'web-ad-banner-bottom'} className={"add_in_main_news_page_appear_here"}>
                                <div>
                                    Google ads will appear here
                                </div>
                            </div>
                        </IonToolbar>
                    </IonFooter>
                    }
                </>:''
            }
        </IonModal>
    );
}
